module.exports = __webpack_public_path__ + "static/branding-c0211259d06a37bd3ae801c48cb6514d.webp";